// 発注ボード
import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import ExcelCsv from "./js/ExcelCsv";

import {addBoardFunction} from './js/BoardFunction';
import Cookies from 'js-cookie'
import './css/board.css';


export default class Board extends Component{
  state={
    //authObj:{},
    tonya_obj_array:this.props.data.tonya_datas,
    re_tonya_array:[],
    click_tonya_id:0
  }
  
  constructor(props) {
    super(props);
  }
  

  //onUnload = e => { // the method that will be used for both add and remove event
  //  const confirmationMessage = 'Some message';
  //  e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
  //  return confirmationMessage;   
  //}
 
  componentDidMount () {
    //console.dir(this.props.data.cm_datas); 
    // CmListBody で使用するデータをもらおうと思うと render に書かないとだめ、非同期で GET している、 render 負荷考慮でここで再取得...
    // と思ったが、 stream のことを考えると...
    //console.dir(this.props.data.tonya_datas); 
    //console.dir(this.props.data); 
    //console.log(this.state.tonya_obj_array);

    //let re_tonya_obj_array = addBoardFunction.convertTonyaArray(this.state.tonya_obj_array);
    //console.dir(re_tonya_obj_array);
    //this.setState({re_tonya_array:re_tonya_obj_array});
		//let staff_token = Cookies.get('_replace_token');
		//let staff_name = Cookies.get('_replace_staff');
		//this.setState({authObj:{"token":staff_token, "name":staff_name}})

    if(this.props.data.tonya_datas_id_fix.length>0){
      let tonya_list = addBoardFunction.boardSoart(this.props.data.tonya_datas, this.props.data.tonya_datas_id_fix);
      this.props.getTonyaDatas(tonya_list);
    }

    //window.addEventListener("beforeunload", this.onUnload);

  }

  //componentWillUnmount() {
  //  window.removeEventListener("beforeunload", this.onUnload);
  //}


  onClickDwonloadButton(args){
		console.dir(args);
  }

  
  jumpTonya = async (e) => {
    //console.dir(e.target);
    let this_tonya = e.target.dataset.tonya; // tonya_name_f
    this.props.changeTonyaLabel(e.target.dataset.tonya); //表の変更イベントは CmList.js 内

    document.getElementById('search-form').scrollIntoView({behavior:"smooth"});
    
    let tonya_id = e.target.dataset.tonya_id_1;
    if(this.state.click_tonya_id===0 || tonya_id!==this.state.click_tonya_id){
      this.setState({click_tonya_id:Number(tonya_id)});
    }else{
      this.setState({click_tonya_id:0});
    }

    this.props.changeFormDataCutHattyuu([]);
    e.preventDefault();
  }
  
  
  render(){
    var checkboxClick = async (e) => {
      console.dir(e.target)

      if(this.props.data.table_tonya_label!=='all'){
        let alert_box = window.confirm('発注を確定.\n\n'+String(this.props.data.table_tonya_label)+'\n\n進めていいですか？');
        if(alert_box===false){
          e.target.checked = false;
          return 'check_false';
        }
      }


      if(this.props.data.formDataCutHattyuu.length>0){
        let alert_box = window.confirm('発注除外があります.\n'+String(this.props.data.formDataCutHattyuu.length)+'件\n進めていいですか？');
        if(alert_box===false){
          e.target.checked = false;
          return 'check_false';
        }
      }


      let tonya_id = Number(e.target.dataset.dbId);
      let tonya_name_f = String(e.target.dataset.dbName);
      let obj_name = '';
			console.dir(e.target);
      if(e.target.checked){
        let _elm = e.target.parentNode.parentNode.childNodes[1];
        _elm.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only"></span></div>';

        // chnage table: cm_order
        let res_2 = addBoardFunction.updateCmOrderHattyuu(e.target, this.props.data.auth_obj, this.props.data);
        console.log(res_2);

        if(res_2==='check_false'){
          e.target.checked = false;
          return '';
        }
        // chnage table: tonya
        let res = addBoardFunction.updateHattyuuDate(e.target, this.props.data.auth_obj);
        console.log(res);

        if(res_2==='check_false'){
          _elm.innerHTML = '';
          e.target.checked = false;
        }else{
          console.log('発注残更新 '+String(res_2));
          for (let i = 0; i < this.props.data.tonya_datas.length; i++) {
            let obj_id = Number(this.props.data.tonya_datas[i].id);
            if(obj_id===tonya_id){
              this.props.data.tonya_datas[i].hattyuu_zan = this.props.data.tonya_datas[i].hattyuu_zan - res_2;
              //this.props.getTonyaDatas(this.props.data.tonya_datas);
            }
          }
          this.props.getTonyaDatas(this.props.data.tonya_datas);

          let todayDate = new Date();
          let today_str = (todayDate.getMonth()+1) + '/' + todayDate.getDate() + ' '+todayDate.getHours()+':'+todayDate.getMinutes() ;
          for (let i = 0; i < this.props.data.dataArray.length; i++) {
            obj_name = String(this.props.data.dataArray[i].which_tonya);
            if(obj_name===tonya_name_f){
              this.props.data.dataArray[i].hattyuu_date = today_str;
              
            }
          }
          console.log('obj_name:'+String(obj_name)+' tonya_name_f:'+tonya_name_f);
          this.props.getDataArray(this.props.data.dataArray);
          //console.dir(this.props.data.dataArray);

          let tonya_list2 = addBoardFunction.board2Soart(this.props.data.dataArra);
          this.props.getTonyaDatas2(tonya_list2);

          this.props.changeFormDataCutHattyuu([]);
        }
      }
      //e.preventDefault();
		}


    //console.dir(this.props.data.formDataCutHattyuu); 

    return (
      <div className="board-area bg-light mb-5 p-3 container"  >
				<table>
					<thead>
						<tr className="table-row sticky-top my-bh">
							<td className="table-col">No.</td>
							<td className="table-col nowrap td-relative">問屋名</td>
              <td className="table-col nowrap">発注完了？</td>
							<td className="table-col nowrap">発注残数</td>
							<td className="table-col nowrap">締切時刻</td>
							<td className="table-col">前回発注</td>
							<td className="table-col nowrap">発注方法</td>
              <td className="table-col nowrap">発注日</td>
              <td className="table-col nowrap">発注File</td>
              
						</tr>
					</thead>

					<tbody>
          	{this.props.data.tonya_datas.map((row, index)=>{
              let hattyuu_youbi = addBoardFunction.convertHattyuuYoubi(row);
              let hattyuu_prev_date = null;
              try{
                hattyuu_prev_date = addBoardFunction.converDate(row, 'hattyuu');
              }catch(error){
                
							}
              let hattyuu_deadline_date = addBoardFunction.converDeadLineDate(row);
              //let download_link = addBoardFunction.getDownloadLink(row, this.state.authObj);
              
              let index_circle_class = 'bg-dark rounded-circle index-icon text-white';
              let index_tr_class = 'table-row';
              if(this.state.click_tonya_id===row.id){
                index_circle_class = 'rounded-circle index-icon borad-1-index-now';
                index_tr_class = 'table-row board-1-index-tr';
              }

              let download_button_class = 'download-button-hidden';
              if(row.order_style==='csv' || row.order_style==='xlsx'){
                download_button_class = 'download-button-show';
              }else if( row.tonya_name_f==='マルク.xlsx' || row.tonya_name_f==='三共在庫.csv' || row.tonya_name_f==='アサヒサイクル.xlsx' || row.tonya_name_f==='アサヒシューズ.xlsx' || row.tonya_name_f==='ナビリオン当日.xlsx' || row.tonya_name_f==='ナビリオン愛知以外（当日）.xlsx' || row.tonya_name_f==='ナビリオン愛知以外.xlsx' || row.tonya_name_f==='ナビリオン.xlsx'){
                download_button_class = 'download-button-show maruku-button-style';
              }


          	  return(
								<tr key={'b1_'+row.id} className={index_tr_class}>
                  
                  <td className="table-col nowrap ">
                    <div 
                      className={index_circle_class}
                      data-tonya={row.tonya_name_f}
                      data-tonya_id_1={row.id}
                      onClick={this.jumpTonya} 
                    >
                      {index+1}
                    </div>
                  </td>
									
                  <td className="table-col nowrap">
                    {row.url.indexOf('http')!==-1 ? 
                      <>
                        <a href={row.url} target="_blank" className="small text-decoration-none">{row.tonya_name}</a>
                      </> : 
                      <>
                        <span>{row.tonya_name}</span>
                      </>
                    }
                    
                  </td>

                  <td className="table-col nowrap position-relative">
                    {this.props.data.isit_now_data_importing ? 
                      <>
                        <Form.Check
										    	id={row.id}
                          data-db-id={row.id}
                          data-db-name={row.tonya_name_f}
										    	onClick={event=>checkboxClick(event)}
                          disabled
										    />
                      </> 
                      : 
                      <>
                        <Form.Check
										    	id={row.id}
                          data-db-id={row.id}
                          data-db-name={row.tonya_name_f}
										    	onClick={event=>checkboxClick(event)}
										    />
                      </>
                    }

                    <div id={"checkbox_1_"+row.id} className="checkbox_loading_icon"></div>
                  </td>
									
                  <td className="table-col nowrap">{row.hattyuu_zan}</td>
									<td className="table-col nowrap">{hattyuu_deadline_date}</td>
									<td className="table-col nowrap">{hattyuu_prev_date}（{row.hattyuu_owari_who}）</td>
									<td className="table-col nowrap">{row.order_style}</td>
									<td className="table-col nowrap">{hattyuu_youbi}</td>
									<td className="table-col nowrap">
                    {/*  
                    <a href={download_link} className={row.order_style==='csv' ? 'btn btn-sm btn-outline-secondary  a-small' : ''}>
                      {row.order_style==='csv' ? '発注用CSVダウンロード' : ''}
                    </a>
                    */}

                    <ExcelCsv
                      downloadButton={this.onClickDwonloadButton.bind(this)} 
                      data={this.props.data} 
                      tonya_id= {row.id}
                      tonya_name_f= {row.tonya_name_f}
                      format = {row.order_style}
                      style_class={download_button_class}
                      what_type={'hattyuu'}
                    />
                  </td>
                 
								</tr>

          	  )
          	})}
						
					</tbody>


				</table>
        
      </div>
    );
  }
}